import axios from "axios";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { toast } from "react-toastify";
import { mediaUpload } from "../../../../api/api";
import EditUploadCodes from "./EditUploadCodes";

const UploadCodes = forwardRef(({ pullBack, indexLinks, haveActivationKey = false, subjectBranchId }, ref) => {

    const [files, setFiles] = useState([])
    const [uploadedFiles, setUploadedFiles] = useState([])

    const [activeUploadBtn, setActiveUploadBtn] = useState(haveActivationKey)
    const [loading, setLoading] = useState(false)

    const fileInputRef = useRef(null)

    const allowedFormats = [".txt"]


    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files)
        const acceptedFiles = selectedFiles.filter((file) =>
            allowedFormats.some((format) => file.name.toLowerCase().endsWith(format))
        )

        if (acceptedFiles.length < selectedFiles.length) {
            toast.error("فقط فایل‌های با فرمت txt مجاز هستند")

        } else {

            setFiles((prevFiles) => [...prevFiles, selectedFiles[0]])
            event.target.value = null
        }
    }

    const handleUploadClick = () => {
        fileInputRef.current.click()
    }

    const handleDelete = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    }


    useImperativeHandle(ref, () => ({
        async preSubmitAction() {
            const indicesToRemove = [];
            let mediaIds = []

            // اپلود فایل های امینیتی قبل از ذخیره عنوان
            for (let index = 0; index < files.length; index++) {

                const formData = new FormData();
                const file = files[index];
                formData.append("file", file);

                try {
                    setLoading(true)
                    const res = await axios.post(mediaUpload, formData);
                    console.log(file);
                    const mediaId = res.data.mediaId

                    mediaIds.push(mediaId)
                    pullBack(mediaIds, indexLinks)
                    setUploadedFiles(prev => [...prev, {
                        mediaId: mediaId,
                        fileName: file.name
                    }]);

                    indicesToRemove.push(index)

                } finally {
                    setLoading(false)
                }
            }

            //حذف فایل اپلود شده از دیتا
            setFiles((prevFiles) => prevFiles.filter((_, i) => !indicesToRemove.includes(i)));
        }

    }));


    return (
        <div>
            <div className="d-flex align-items-center gap-3">
                <span style={{ width: 115 }}>کد فعالسازی:</span>

                <select style={{ width: '50%' }} onChange={(e) => setActiveUploadBtn(!activeUploadBtn)} defaultValue={activeUploadBtn ? "2" : "1"}>
                    <option value="1">ندارد</option>
                    <option value="2">دارد</option>
                </select>

                <button
                    onClick={handleUploadClick}
                    disabled={loading || !activeUploadBtn}
                    className="addMore btnUploadCode"
                    type="button"
                >
                    {loading ? "لطفا صبر کنید..." : "آپلود فایل"}
                </button>

                <input
                    type="file"
                    // multiple
                    onChange={handleFileChange}
                    ref={fileInputRef}
                    style={{ display: "none" }}
                />
            </div>

            {files.length > 0 && (
                <div className="mt-3">
                    <span className="mb-1 d-block">لیست فایل های کدفعالسازی آپلود نشده:</span>
                    {files.map((file, i) => (
                        <div
                            key={file.i + file.name}
                            className="d-flex align-items-center justify-content-between gap-2"
                        >
                            <input type="text" readOnly value={file.name} style={{ fontWeight: 300 }} />
                            <button
                                onClick={() => handleDelete(i)}
                                className="removeFileBtn"
                                type="button"
                            >
                                حذف فایل
                            </button>
                        </div>
                    ))}
                </div>
            )}

            <EditUploadCodes haveActivationKey={haveActivationKey} subjectBranchId={subjectBranchId} setUploadedFiles={setUploadedFiles} uploadedFiles={uploadedFiles} />

        </div>
    );
})

export default UploadCodes;